import { gql } from '@apollo/client';

export const GET_PUSH_HISTORY = gql`
  query GetPushHistory($subTenantId: String) {
    tm {
      enterprisePushHistory(subTenantId: $subTenantId) {
        subTenantId
        subAccountName
        datePushed
        status
        changeCount
        pendingCount
        entitySummary
      }
    }
  }
`;
